import { post } from 'core/helpers/fetch';
import {
  START_HANGEDMAN_ROUND_STARTED,
  START_HANGEDMAN_ROUND_SUCCEED,
  START_HANGEDMAN_ROUND_FAILED,
} from 'app/games/hangedman/reducers/instances';

export default function startRound(instanceId, word) {
  return async dispatch => {
    dispatch({ type: START_HANGEDMAN_ROUND_STARTED, payload: { instanceId: instanceId, word }});
    try {
      const instance = await dispatch(
        post(`/games/hangedman/instances/${instanceId}/startRound`, {
          word,
        })
      );
      dispatch({
        type: START_HANGEDMAN_ROUND_SUCCEED,
        payload: {
          instance,
        }
      });
    } catch (exception) {
      dispatch({ type: START_HANGEDMAN_ROUND_FAILED, payload: { instanceId: instanceId, exception } });
      throw exception;
    }
  };
}
